import "./PageTitle.css"

import { useMemo } from "react"
import { Dropdown } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { MODALS } from "@/constants/modals"
import { useProfileData, useSettingsData } from "@/queries/queries"
import { videoIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"

import NotificationsButton from "@/features/pages/Notifications/NotificationsButton/NotificationsButton"
import { FaUserAlt } from "react-icons/fa"
import LogoutBtn from "../LogoutBtn/LogoutBtn"

export default function PageTitle({ title }: { title: string }) {
  const authData = useStore((state) => state.authData)
  const editModalState = useStore((state) => state.editModalState)
  const { data: settings } = useSettingsData()

  const { i18n } = useTranslation()

  const startLink = useMemo(() => {
    return settings?.filter((el) => el?.key === "start_link")[0]
  }, [settings])

  const isPlaylist = startLink?.value.includes("playlist")

  const { data } = useProfileData()
  return (
    <>
      <div className=" page-title d-flex justify-content-between align-items-center">
        <h1 className="d-none d-md-block">{title}</h1>

        <div className=" d-flex gap-4 justify-content-between justify-content-md-end align-items-center ">
          {/* Language Dropdown */}
          <span
            onClick={() =>
              isPlaylist
                ? window.open(startLink?.value, "_blank")
                : editModalState(MODALS.lecture.video, startLink)
            }
            className="start_video"
          >
            {videoIcon}
          </span>
          <NotificationsButton />
          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              className="d-flex align-items-center gap-2 custom-toggle"
            >
              <span>{i18n.language === "en" ? "En" : "ع"}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="lang_menu">
              <Dropdown.Item
                className="py-3"
                onClick={() => i18n.changeLanguage("en")}
              >
                {/* eslint-disable-line i18next/no-literal-string */}En
              </Dropdown.Item>
              <Dropdown.Item
                className="py-3"
                onClick={() => i18n.changeLanguage("ar")}
              >
                {/* eslint-disable-line i18next/no-literal-string */}ع
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* Profile Dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="light"
              className="d-flex align-items-center gap-2 custom-toggle "
            >
              <div className="profile__icon">
                {data?.image ? (
                  <img src={data?.image} className="rounded-circle" />
                ) : (
                  <FaUserAlt size={22} />
                )}
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="shadow profile_menu ">
              <div className="d-flex gap-3 align-items-center mb-3 ">
                <span className="profile__icon">
                  {data?.image ? (
                    <img src={data?.image} className="rounded-circle" />
                  ) : (
                    <FaUserAlt size={22} />
                  )}
                </span>
                <div>
                  <div className="profile__name fw-bold">
                    {authData?.user?.name || ""}
                  </div>
                  <div className="profile__email ">
                    {authData?.user?.email || ""}
                  </div>
                </div>
              </div>
              <Dropdown.Divider />
              <Dropdown.Item className="text-danger d-flex align-items-center gap-2">
                <LogoutBtn />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </>
  )
}
